@if (showCredentialTypes$ | async) {
  <bit-toggle-group
    fullWidth
    class="tw-mb-4"
    [selected]="credentialType$ | async"
    (selectedChange)="onCredentialTypeChanged($event)"
    [label]="'type' | i18n"
  >
    @for (option of passwordOptions$ | async; track option) {
      <bit-toggle [value]="option.value">
        {{ option.label }}
      </bit-toggle>
    }
  </bit-toggle-group>
}
<bit-card class="tw-flex tw-justify-between tw-mb-4">
  <div class="tw-grow tw-flex tw-flex-col tw-justify-center tw-min-w-0">
    <bit-color-password class="tw-font-mono" [password]="value$ | async"></bit-color-password>
    @if ((algorithm$ | async)?.id === Algorithm.passphrase) {
      <p class="tw-mb-0 tw-mt-2 tw-text-sm tw-text-muted">
        {{ "length" | i18n }}: {{ valueLength$ | async }}
      </p>
    }
  </div>
  <div class="tw-flex tw-items-center tw-space-x-1">
    <button
      type="button"
      bitIconButton="bwi-generate"
      buttonType="primaryGhost"
      (click)="generate(USER_REQUEST)"
      [label]="credentialTypeGenerateLabel$ | async"
      [disabled]="!(algorithm$ | async)"
    >
      {{ credentialTypeGenerateLabel$ | async }}
    </button>
    <button
      type="button"
      bitIconButton="bwi-clone"
      buttonType="primaryGhost"
      showToast
      [label]="credentialTypeCopyLabel$ | async"
      [appCopyClick]="value$ | async"
      [valueLabel]="credentialTypeLabel$ | async"
      [disabled]="!(algorithm$ | async)"
    ></button>
  </div>
</bit-card>
@if ((algorithm$ | async)?.id === Algorithm.password) {
  <tools-password-settings
    class="tw-mt-6"
    [account]="account$ | async"
    [disableMargin]="disableMargin"
    (onUpdated)="generate('password settings')"
  />
}
@if ((algorithm$ | async)?.id === Algorithm.passphrase) {
  <tools-passphrase-settings
    class="tw-mt-6"
    [account]="account$ | async"
    (onUpdated)="generate('passphrase settings')"
    [disableMargin]="disableMargin"
  />
}
